import PopupManager from './modules/popupManager.js';

(function (Drupal, drupalSettings, once) {
  Drupal.behaviors.noahsPopupLoader = {
    attach(context, settings) {

      once('noahsPopupLoader', 'body', context).forEach(() => {
        const popups = drupalSettings.noahs_popups?.popups || [];
        const currentNodeId = drupalSettings.noahs_popups?.nid?.toString() ?? null;

        const manager = new PopupManager(popups, currentNodeId);
        window.NoahsPopupManager = manager;
        manager.init();
      });

    }
  };
})(Drupal, drupalSettings, once);
 
